import { render, staticRenderFns } from "./WorkFlowModal.vue?vue&type=template&id=3b47d487&scoped=true&"
import script from "./WorkFlowModal.vue?vue&type=script&lang=js&"
export * from "./WorkFlowModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowModal.vue?vue&type=style&index=0&id=3b47d487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47d487",
  null
  
)

export default component.exports